// Lazy wrapper around the Leaflet map so the ~150 KB leaflet bundle is only
// downloaded when a map is actually rendered (keeps the recipient PWA + every
// non-map page lean). Same API as LeafletMap.

import { lazy, Suspense } from 'react';
import type { MapViewProps, MapMarker } from './LeafletMap';

export type { MapMarker };

const LeafletMap = lazy(() => import('./LeafletMap').then((m) => ({ default: m.LeafletMap })));

export function MapView(props: MapViewProps) {
  return (
    <Suspense fallback={<div style={{ height: props.height ?? '320px' }} className="bg-slate-100 animate-pulse rounded-xl" />}>
      <LeafletMap {...props} />
    </Suspense>
  );
}
